export enum EngravingOptionType {
  Message = 'Message',
  Initials = 'Initials',
  Date = 'Date',
}

export const OPTIONS = [
  EngravingOptionType.Message,
  EngravingOptionType.Initials,
  EngravingOptionType.Date,
] as const;

export type OptionType = EngravingOptionType;

export const STYLES = ['Block', 'Cursive'] as const;
export type StyleType = (typeof STYLES)[number];

export const SIZES = ['M', 'L'] as const;
export type SizeType = (typeof SIZES)[number];
